module.exports = __webpack_public_path__ + "static/media/icons-ic-dispositions-closed-demo.602044a7.svg";